const signRequest = (config) => {
  config.headers['Authorization'] = 'application ' + process.env.COMPETITOR_API_KEY
}

export {
  signRequest
}



// WEBPACK FOOTER //
// ./src/api/competitor/authorization.js